import Layout from '../../../components/Layout/Auth';
import Content from '../../../components/Pages/Auth/EmailVerificationToken';
import { displayName } from '../../../config';
import Wrapper from '../../../components/Pages/Auth';

const EmailVerificationToken = (): JSX.Element => {
  document.title = `${displayName}: Email Verification Token`;

  return (
    <Layout>
      <Wrapper>
        <Content />
      </Wrapper>
    </Layout>
  );
};

export default EmailVerificationToken;
